import { faTrashAlt, faMultiply, faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { BackupData } from "../../model/CarbonExternalModels";
import { deleteBackup } from "../../store/backup/backupManager";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { Button } from "userful-chronos-common-ui/dist";

interface IProps {
    backup: BackupData;
}

export default function BackupDelete(props: IProps) {
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    if (!permissions.isClusterSuppressor) return null;

    return (
        <>
            <Dropdown.Item
                onClick={() => {
                    setShowConfirmation(true);
                }}
            >
                <div className="gcm-icon-dropdown-menu-icon-container">
                    <FontAwesomeIcon icon={faTrashAlt} />
                </div>
                <p>Delete</p>
            </Dropdown.Item>

            <Modal
                centered
                show={showConfirmation}
                onHide={() => {
                    setShowConfirmation(false);
                }}
            >
                <div className="gcm-pop-up-modal-wrapper">
                    <div className="gcm-pop-up-modal-wrapper-body">
                        <div className="gcm-pop-up-modal-wrapper-head">
                            <div className="gcm-pop-up-modal-wrapper-title">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                                <h1>Delete Backup</h1>
                            </div>
                            <Button
                                variant="secondary"
                                iconOnly
                                onClick={() => {
                                    setShowConfirmation(false);
                                }}
                            >
                                <FontAwesomeIcon icon={faMultiply} />
                            </Button>
                        </div>
                        <p>
                            Are you sure you want to delete the backup: <strong>"{props.backup.metadata.name}"</strong>?
                            This will permanentaly remove all the data related this backup.
                        </p>
                    </div>
                    <div className="confirmationDialogHorizontalWrapper reversed">
                        <Button
                            variant="danger"
                            onClick={(e) => {
                                setShowConfirmation(false);
                                deleteBackup(props.backup, "INTERNAL");
                            }}
                        >
                            Delete
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={(e) => {
                                setShowConfirmation(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
